// import api from "../../api";
import api from "../../../api"

export function getPrescription(sd, ed, page="1") {
  return api.get(`prescribed_patients?startDate=${sd}T18%3A30%3A00.000Z&endDate=${ed}T18%3A29%3A59.999Z&pageNo=${page}`);
}










